<template>
 <div>
   {{ ver }}
 </div>
</template>

<script>
export default {
  name: "VersionView",
  title: "Версия",
  data: function() {
    return {
      ver: process.env.PACKAGE_VERSION
    }  
  }
};
</script>